import React, { Component, Fragment } from 'react';
import UserProfile from './UserProfile/UserProfile';

class User extends Component {
    render() {
        console.log(this.props);

        return (
            <Fragment>
                <UserProfile signout={this.props.signout} />
            </Fragment>
        );
    }
}

export default User;
